import MaterialDialogTitle, {
    DialogTitleProps,
} from '@mui/material/DialogTitle';

export function DialogTitle(props: DialogTitleProps) {
    return <MaterialDialogTitle data-testid={'Dialog-container'} {...props} />;
}

export default DialogTitle;
